import { EntityService } from "@/model/service/entity-service"
import { Company } from "@/model/entity/company/company"
import { AxiosPromise } from "axios"

export interface IDefaultStatuses {
  name: string
  value: string
}
class CompanyService extends EntityService<Company> {
  constructor() {
    super("company", Company)
  }

  getDefaultStatuses(): AxiosPromise<IDefaultStatuses[]> {
    return this.$http.get(this.path + "/statuses/")
  }
}

export interface ICompanyService extends EntityService<Company> {}

const service = new CompanyService()

export const companyService = service
